<mat-card id="printContent">
  <mat-card-header class="plate-info-justify-content-between">
    <ng-container *ngIf="alarmIcon" matCardAvatar>
      <sn-icon [fontIcon]="alarmIcon" fontSet="fs" *ngIf="alarmIcon"></sn-icon>
    </ng-container>
    <ng-container *ngIf="!alarmIcon" matCardAvatar>
      <sn-icon fontSet="fal" fontIcon="fa-car"></sn-icon>
    </ng-container>
    <mat-card-title class="plate-info-text-truncate"
      ># {{ data.plate.details.plate }}</mat-card-title
    >
    <sn-icon-button [matMenuTriggerFor]="menu" class="plate-info-pr-2">
      <sn-icon>more_vert</sn-icon>
    </sn-icon-button>
  </mat-card-header>
  <mat-card-content>
    <div class="section-img" *ngIf="this.mediaCarousel.length">
      <img [src]="activeMedia?.url" class="image" (error)="setPlaceholderImage($event)" />

      <div *ngIf="this.mediaCarousel.length > 1" class="arrowBtns">
        <sn-icon class="arrowRight" (click)="nextImg()" fontSet="fal" fontIcon="fa-chevron-left">
        </sn-icon>
        <div *ngIf="this.mediaCarousel.length > 1" class="media-nav-scale">
          <button
            class="media-nav-scale-item"
            *ngFor="let media of this.mediaCarousel; trackBy: trackMedia"
            [class.active]="isActive(media)"
            (click)="selectMedia(media)"
          ></button>
        </div>
        <sn-icon
          class="arrowLeft"
          (click)="previousImg()"
          fontSet="fal"
          fontIcon="fa-chevron-right"
        >
        </sn-icon>
      </div>
    </div>
    <div class="info-section">
      <p *ngIf="data.plate.eventTimestamp">
        <span class="detailKey">Date Read: </span>
        {{ data.plate.eventTimestamp | fsFormatDate : 'medium' }}
      </p>
      <p *ngIf="data.plate.createdTimestamp">
        <span class="detailKey">Date Received: </span>
        {{ data.plate.createdTimestamp | fsFormatDate : 'medium' }}
      </p>
      <dl>
        <ng-container *ngIf="data.plate.integratedLprType === 'flock'">
          <ng-container *ngFor="let detail of data.plate | keyvalue : originalOrder">
            <ng-container *ngIf="!excludeFlockData(detail.key)">
              <dd>
                <span class="detailKey">{{ detail.key }}:</span>
                {{ isTimestamp(detail.key) ? formatDate(detail.value) : parseFlockData(detail) }}
              </dd>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngFor="let detail of data.plate.details | keyvalue : originalOrder">
          <div *ngIf="!exclude(detail.key)">
            <ng-container [ngSwitch]="true">
              <ng-container *ngSwitchCase="isObject(detail.value)">
                <h4 class="detailKey">{{ detail.key }}:</h4>
                <ul class="secondaryList">
                  <ng-container *ngFor="let item of detail.value | keyvalue : originalOrder">
                    <ng-container [ngSwitch]="true">
                      <ng-container *ngSwitchCase="isObject(item.value)">
                        <li class="secondaryListItem">
                          <div class="detailKey">{{ item.key }}:</div>
                          <ul class="secondaryList">
                            <div
                              class="subItem"
                              *ngFor="let subItem of item.value | keyvalue : originalOrder"
                            >
                              <li class="secondaryListItem">
                                <span class="detailKey">{{ subItem.key }}:</span>
                                {{ subItem.value ? subItem.value : 'N/A' }}
                              </li>
                            </div>
                          </ul>
                        </li>
                      </ng-container>
                      <ng-container *ngSwitchCase="isArrays(item.value)">
                        <ng-container *ngIf="item?.value?.length">
                          <h4 class="detailKey">{{ item.key }}:</h4>
                          <ul class="secondaryList">
                            <div
                              class="subItem"
                              *ngFor="let subItem of item.value | keyvalue : originalOrder"
                            >
                              <div
                                *ngFor="let subItem2 of subItem.value | keyvalue : originalOrder"
                              >
                                <li class="secondaryListItem">
                                  <span class="detailKey">{{ subItem2.key }}:</span>
                                  {{ subItem2.value ? subItem2.value : 'N/A' }}
                                </li>
                              </div>
                            </div>
                          </ul>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="subItem">
                          <li class="secondaryListItem">
                            <span class="detailKey">{{ item.key }}:</span>
                            {{ item.value ? item.value : 'N/A' }}
                          </li>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ul>
              </ng-container>
              <ng-container *ngSwitchCase="isArrays(detail.value)">
                <ng-container *ngIf="detail.value?.length">
                  <h4 class="detailKey">{{ detail.key }}:</h4>
                  <ul class="secondaryList">
                    <ng-container *ngIf="detail.key === 'Plate Analytics'; else recursiveTmpl">
                      <ng-container *ngFor="let item of formatDataKeys(detail.value)">
                        <li class="secondaryListItem">
                          <span class="detailKey">{{ item.key }}:</span>
                          {{ item.value ? item.value : 'N/A' }}
                        </li>
                      </ng-container>
                    </ng-container>
                    <ng-template #recursiveTmpl>
                      <div
                        class="subItem"
                        *ngFor="let item of detail.value | keyvalue : originalOrder"
                      >
                        <ng-container [ngSwitch]="true">
                          <ng-container *ngSwitchCase="isObject(item.value)">
                            <ng-container
                              *ngFor="let subItem of item.value | keyvalue : originalOrder"
                            >
                              <li class="secondaryListItem">
                                <span class="detailKey">{{ subItem.key }}:</span>
                                {{ subItem.value ? subItem.value : 'N/A' }}
                              </li>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngSwitchCase="isArrays(item.value)">
                            <ng-container *ngIf="item?.value?.length">
                              <h4 class="detailKey">{{ item.key }}:</h4>
                              <ul class="secondaryList">
                                <div
                                  class="subItem"
                                  *ngFor="let subItem of item.value | keyvalue : originalOrder"
                                >
                                  <div
                                    *ngFor="
                                      let subItem2 of subItem.value | keyvalue : originalOrder
                                    "
                                  >
                                    <li class="secondaryListItem">
                                      <span class="detailKey">{{ subItem2.key }}:</span>
                                      {{ subItem2.value ? subItem2.value : 'N/A' }}
                                    </li>
                                  </div>
                                </div>
                              </ul>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngSwitchDefault>
                            <li class="secondaryListItem">
                              <span class="detailKey">{{ item.key }}:</span>
                              {{ item.value ? item.value : 'N/A' }}
                            </li>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ul>
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <dd>
                  <span class="detailKey">{{ detail.key }}:</span>
                  {{
                    isTimestamp(detail.key)
                      ? formatDate(detail.value)
                      : detail.value?.length
                      ? detail.value
                      : 'N/A'
                  }}
                </dd>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </dl>
    </div>
  </mat-card-content>
</mat-card>

<mat-menu #menu="matMenu">
  <button mat-menu-item matTooltip="Print" color="success" (click)="printLpr()">
    <sn-icon fontSet="fal" fontIcon="fa-print"></sn-icon>
    <span>Print</span>
  </button>
  <button
    mat-menu-item
    matTooltip="Enlarge Image"
    color="success"
    (click)="openEnlargedImageDialog()"
  >
    <sn-icon fontSet="fal" fontIcon="fa-external-link"></sn-icon>
    <span>Enlarge Image</span>
  </button>
  <button
    *ngIf="data.plate.integratedLprType !== 'flock'"
    mat-menu-item
    (click)="sendToVault(data)"
  >
    <sn-icon>queue_play_next</sn-icon>
    <span>Send To Vault</span>
  </button>
</mat-menu>
